import {BehaviorSubject, take} from 'rxjs';
import type {EIP1193RequestFn, PublicClient, Transport} from 'viem';
import {watchAccount as originWatchAccount, type GetAccountResult, type Chain} from '@wagmi/core';
import {bridge} from '@/helper/bridge';
import {readWalletConnectOriginName} from '../shared';
import {defineWalletConnectBridge, shouldUseAppWalletConnect$} from '../bridge';

export const connector$ = new BehaviorSubject<ConnectorData>({connectorType: '', walletType: '', connector: null, address: ''});

export function watchAccount() {
  if (!process.browser) {
    return;
  }

  shouldUseAppWalletConnect$.pipe(take(1)).subscribe((shouldUseAppWalletConnect) => {
    if (shouldUseAppWalletConnect) {
      watchAccountByApp();
      return;
    }
    watchAccountByWeb();
  });
}

function watchAccountByWeb() {
  originWatchAccount((account) => {
    const connectorType = account?.connector?.name as SupportConnectors;
    const walletType = connectorType === suppportConnectors.metaMask ? connectorType : readWalletConnectOriginName();
    const address = account?.address;
    connector$.next({connectorType, connector: account, walletType, address});
  });
}

const APP_WATCH_ACCOUNT_METHOD_NAME = 'appWatchAccount';
defineWalletConnectBridge(() => {
  // app端监听连接状态
  (window as any)[APP_WATCH_ACCOUNT_METHOD_NAME] = function (response) {
    try {
      const {code, data} = JSON.parse(response);
      if (code === 0) {
        const {walletSource: connectorType, walletName: walletType, address} = data;
        connector$.next({connectorType, connector: null, walletType, address});
      }
    } catch (error) {
      connector$.next({connectorType: '', connector: null, walletType: '', address: ''});
    }
  };
});

function watchAccountByApp() {
  bridge.postJSON({type: 'watchWalletAccount', callback: APP_WATCH_ACCOUNT_METHOD_NAME});
}

/**
 * 监听自动连接
 */
export function watchAutoConnect() {
  let subscription;
  const promise = new Promise<ConnectorData>((resolve) => {
    subscription = connector$.subscribe((connector) => {
      if (connector?.connector?.isConnected) {
        resolve(connector);
      }
    });
  });

  return {
    promise,
    subscription,
  };
}

export const suppportConnectors = {
  metaMask: 'MetaMask',
  walletConnect: 'WalletConnect',
} as const;

type AccountResult = GetAccountResult<PublicClient<Transport<string, Record<string, any>, EIP1193RequestFn<undefined>>, Chain>>;

export type SupportConnectors = typeof suppportConnectors[keyof typeof suppportConnectors] | '';
interface ConnectorData {
  connectorType: typeof suppportConnectors[keyof typeof suppportConnectors] | '';
  walletType: string;
  address: string;
  connector: AccountResult | null;
}
